module.exports = __webpack_public_path__ + "static/media/showmore_icon.9883c7d4.svg";